import { Circle } from 'components'
import SuccessModal from 'components/SuccessModal'
import * as mixpanel from 'mixpanel-browser'
import * as moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { bindActionCreators, compose } from 'redux'
import { _route } from 'routes/config'
import SnackbarService from 'services/snackbars'
import * as UsersActions from 'store/user/actions'

interface IProps extends RouteComponentProps {
  oobCode: string
  UserLib?: any
  userData?: any
  authData?: any
}

const VerifyEmailBase: React.FC<IProps> = ({
  oobCode,
  UserLib,
  history,
  userData,
  authData
}) => {
  const [showModal, setShowModal] = React.useState(false)

  const openModal = () => {
    // mixpanel.people.set({
    //   'Is Verified': true
    // })

    if (authData) {
      mixpanel.identify(authData.uid)
    }

    mixpanel.track('Verified email')

    // mixpanel.people.set({
    //   'Latest Login Time': moment().format('MMMM Do YYYY, h:mm:ss a')
    // })
    // // *should call user.identify after every `people.set`, check documentation for more details
    // mixpanel.identify(authData?.uid)

    mixpanel.track('Logged in', { date: moment().unix() })

    setShowModal(true)
  }

  React.useEffect(() => {
    const isUserLogged = userData && authData

    UserLib.verifyUser(
      oobCode,
      () => {
        openModal()
      },
      error => {
        console.log(error)

        if (!isUserLogged) {
          SnackbarService.showSnackbar(
            "Your email hasn't been verified. Sign in to the app and try again",
            'error'
          )
        }

        history.replace('/login')
      }
    )
  }, [])

  return showModal ? (
    <SuccessModal subtitle="Email verified" open={true} />
  ) : (
    <Circle />
  )
}

const mapStateToProps = state => {
  return {
    userData: state.user.data,
    authData: state.user.auth
  }
}

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UsersActions, dispatch)
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export const VerifyEmail: any = compose(connector, withRouter)(VerifyEmailBase)



// WEBPACK FOOTER //
// ./src/pages/EmailHandler/VerifyEmail/index.tsx